﻿export const NavigationService = (() => {

  const initNavMenuDropdown = (): void => {
    let navMenuDropdown = document.querySelector('.nav-menu-dropdown');

    if (navMenuDropdown != null) {
      navMenuDropdown.addEventListener('click', function (event) {
        event.stopPropagation();
        navMenuDropdown?.classList.toggle('is-active');
      });
    }
  }

  const initNavBarTitle = (title: string): void => {
    let navMenuTitle = document.querySelector('.nav-menu-title');

    if (navMenuTitle != null) {
      navMenuTitle.textContent = title;
    }
  }

  const openLogOutAlert = async (url: string) => {
    const languageService = (window as any).Mpro.LanguageService;
    
    const alert = await (window as any).Mpro.AlertController.create({
      alertTitle: languageService.translate('page.shared.logout.alert.titleLabel'),
      alertMessage: languageService.translate('page.shared.logout.alert.messageLabel'),
      buttons: [
        {
          text: languageService.translate('page.shared.logout.alert.button.confirmBtn'),
          href: url,
          handler: () => 
          { 
            const keysToRemove = ["nav-menu-cache", "config-nav-menu-cache"];

            keysToRemove.forEach(key =>
              localStorage.removeItem(key));
          },
        },
        {
          text: languageService.translate('page.shared.logout.alert.button.rejectBtn'),
        }
      ],
    });
    
    return alert.present();
  }
  
  return {
    initNavMenuDropdown,
    initNavBarTitle,
    openLogOutAlert,
  };
})();